angular.module('st').requires.push('ngSanitize');
angular.module('st').requires.push('AngularWebService');
angular.module('st').requires.push('AngularMapService');
angular.module('st').requires.push('AngularUtilityService');
angular.module('st').requires.push('AngularGeoService');


//console.info("load", locationsMapCtrl);
angular
    .module('st')
    .controller('locationsMapCtrl', locationsMapCtrl)
    .directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    });

locationsMapCtrl.$inject = ['$scope', '$rootScope', '$sce', '$filter', 'WebService', 'MapService', 'UtilityService', 'GeoService'];

function locationsMapCtrl($scope, $rootScope, $sce, $filter, WebService, MapService, UtilityService, GeoService) {
    var vm = this;

    console.info("locations ctrl");

    vm.findNearMe = findNearMe;
    vm.getInputLocations = GetInputLocations;
    //vm.manualLocationCookie = '';
    vm.init = Init;

    var apiKey;
    var baseUrl;

    function Init(api, mapId, pageUrl, showAllLocations, items) {
        console.info("init items", items);

        apiKey = api;
        baseUrl = pageUrl;

        GeoService.Init(api);
        InitMap(mapId);
        PlaceMarkers(items);
    }

    function InitMap(mapId) {
        var mapOptions = {
            center: new google.maps.LatLng(42.9564627, -85.7301286),
            zoom: 7,
            disableDefaultUI: true,
            gestureHandling: 'cooperative'
        };

        MapService.Init(mapId, mapOptions, baseUrl);
    }

    function PlaceMarkers(items) {
        items.forEach(function (item, i) {
            SetMarker(item);
        });
    }

    function findNearMe() {
        // TODO: make sure Near Me works with current location
        console.info("near me start", GeoService);
        GeoService.GetUserLocation().then(function (result) {
            setLocation(result);
        });
    }

    function setLocation(result) {
        console.info("GetInputLocation", result);

        locationData = {
            "Latitude": result.Latitude,
            "Longitude": result.Longitude,
            "DiameterToSearch": 100,
            "Skip": 0
        };

        retries = 0;

        var mapsPos = { lat: result.Latitude, lng: result.Longitude };

        MapService.SetCenter(mapsPos);
    }

    function SetMarker(item) {
        var directionsLink = "http://maps.apple.com/?saddr=" + item.Address + " " + item.Address2;

        var contentString = '\
                <div class="info-window">\
                    <div class="info-window-contain">\
                        <span>' + item.LocationName + '</span>\
                        <p>' + item.Address + '<br />' + item.Address2 + '</p>\
                        <a href="' + directionsLink + '" target="_blank" class="contact-link"><img src="/Assets/Celebration/Icons/location_small_white.svg" /> Directions</a>\
                        <a href="' + item.PhoneNumber.split("-").join("") + '" class="contact-link"><img src="/Assets/Celebration/Icons/phone_small_white.svg" /> ' + item.PhoneNumber + '</a>\
                    </div>\
                </div>\
            ';

        var latLng = item.GoogleMapUrl.split(",");
        var markerPos = { lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1]) };

        console.info("marker", markerPos);

        MapService.AddInfoMarker(markerPos, "/assets/celebration/icons/movie_theater_map-pin.svg", contentString);
    }

    var retries = 0;
    function GetInputLocations() {
        if (typeof (vm.userInputAddress) != 'undefined') {
            vm.locations = [];

            $rootScope.inputLocation = vm.userInputAddress;
            //if (navigator.cookieEnabled) document.cookie = vm.manualLocationCookie + '=' + vm.userInputAddress;

            console.info("GetInputLocations", vm.userInputAddress);

            GeoService.GetInputLocation().then(function (result) {
                setLocation(result);
            }, function () {
                if (retries !== 5) {
                    GetInputLocations();
                    retries++;
                }
            });
        }
    }
}


